import React from 'react'
import styled from 'styled-components'
import {Row, Col, Button} from 'reactstrap'
import Page from 'ui/page'

import fan from 'goforajourney/img/barcelona/img313'
import sagradaClose from 'goforajourney/img/barcelona/img244'
import laBomba from 'goforajourney/img/barcelona/img247'
import tortilla from 'goforajourney/img/barcelona/img240'
import paellaPan from 'goforajourney/img/barcelona/img241'
import paellaTable from 'goforajourney/img/barcelona/img513'
import metroStation from 'goforajourney/img/barcelona/img263'
import metroEntrance from 'goforajourney/img/barcelona/img516'
import museum from 'goforajourney/img/barcelona/img246'
import casaBatllo from 'goforajourney/img/barcelona/img245'
import beachView from 'goforajourney/img/barcelona/img510'
import cityStreet from 'goforajourney/img/barcelona/img507'
import basilicaIcon from 'goforajourney/img/barcelona/img316'
import gothicPatio from 'goforajourney/img/barcelona/img504'
import parkGuell from 'goforajourney/img/barcelona/img248'
import metroIcon from 'goforajourney/img/barcelona/img237'
import brindis from 'goforajourney/img/barcelona/brindis'
import round from 'goforajourney/img/barcelona/round'

const pink = '#f52549'
const palePink = '#ffd4df'
const ink = '#1f1f1f'
const border = '#1f1f1f'

const dishes = [
  'Jamón Ibérico',
  'Pan con Tomate (Pa amb Tomàquet)',
  'Tortilla de Patata',
  'Croquetas',
  'Patatas Bravas',
  'La Bomba',
  'Seafood Paella',
  'Paella Negra',
  'Fideua',
  'Crema Catalana',
]

const mustSeeSpots = [
  'La Sagrada Familia',
  'Park Güell',
  'Casa Batlló',
  'La Pedrera (Casa Milà)',
  'Casa Vicens',
  'La Boqueria Market',
  'Santa Caterina Market',
  'The Cathedral of Barcelona',
  'The Picasso Museum',
  'Moco Museum',
]

const classicRestaurants = [
  {
    area: 'The Gothic Quarter',
    places: ['La Alcoba Azul', 'La Plata', 'Los Caracoles'],
  },
  {
    area: 'El Born',
    places: ['Ca’l Pep', 'Bodega La Tinaja', 'el SET'],
  },
  {
    area: 'Barceloneta',
    places: ['La Bombeta', 'Can Ramonet', 'Arenal Restaurante'],
  },
]

const alternativeRestaurants = [
  {
    area: 'Gracia',
    places: ['Contracorrent Bistro', 'La Pepita', 'La Rovira'],
  },
  {
    area: 'Sant Antoni',
    places: ['Maleducat', 'Pepa Tomate Parlament', 'Bar Alegria'],
  },
  {
    area: 'Poble Sec',
    places: ['Quimet & Quimet', 'Taberna Noroeste', 'La Platilleria'],
  },
]

const metroTickets = [
  {
    name: 'T-familiar ticket',
    type: 'multi-person ticket',
    journeys: '8 journeys',
    price: '€ 11.50',
  },
  {
    name: 'T-casual ticket',
    type: 'single-person ticket',
    journeys: '10 journeys',
    price: '€ 13',
  },
  {
    name: 'Single ticket',
    type: 'single-person ticket',
    journeys: '1 journey',
    price: '€ 2.90',
  },
]

const catalanPhrases = [
  ['Hello!', 'Hola!'],
  ['Goodbye', 'Adéu'],
  ['Please', 'Si us plau'],
  ['Thank you', 'Gràcies'],
  ['Sorry/Excuse me', 'Perdó'],
  ['Where is…', 'A on és…?'],
  ['Do you speak English?', 'Parles Anglès?'],
  ['The check, please.', 'El compte, si us plau.'],
  ['I don’t understand', 'No ho entenc'],
  ['Where is the bathroom?', 'On és el lavabo?'],
  ['My name is…', 'Em dic…'],
  ['How much does this cost?', 'Quant costa això?'],
  ['I would like…', 'Voldria…'],
  ['Good morning', 'Bon dia'],
  ['How are you?', 'Com estàs?'],
  ['Left', 'Esquerra'],
  ['Right', 'Dreta'],
  ['Straight ahead', 'Recte'],
]

const Poster = styled.div`
  max-width: 1230px;
  color: ${ink};
  line-height: 1.25;
`

const Hero = styled.div`
  min-height: 260px;
  background:
    linear-gradient(
      135deg,
      rgba(245, 37, 73, 0.9),
      rgba(31, 31, 31, 0.55)
    ),
    url(${({$background}) => $background});
  background-size: cover;
  background-position: center;
  overflow: hidden;
`

const HeroContent = styled.div`
  position: relative;
  z-index: 2;
`

const HeroTitle = styled.h1`
  font-size: clamp(3rem, 8vw, 6rem);
  font-weight: 900;
  line-height: 0.95;
  text-shadow: 0 4px 18px rgba(0, 0, 0, 0.25);
`

const HeroSubtitle = styled.div`
  font-size: 1.1em;
  display: inline-block;
  background: rgba(255, 255, 255, 0.18);
  border: 2px solid rgba(255, 255, 255, 0.45);
  border-radius: 999px;
  padding: 0.55rem 1.25rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  backdrop-filter: blur(4px);
`

const BasilicaIcon = styled.img`
  right: 28px;
  bottom: -12px;
  width: 110px;
  opacity: 0.9;
  filter: drop-shadow(0 6px 12px rgba(0, 0, 0, 0.25));
`

const Pill = styled.div`
  background: ${({$dark, $sub}) => ($dark ? ink : $sub ? palePink : pink)};
  color: ${({$dark, $sub}) => ($dark || !$sub ? '#fff' : ink)};
  letter-spacing: ${({$sub}) => ($sub ? 'normal' : '0.08em')};
`

const PillTitle = ({children, dark = false, className = ''}) => (
  <Pill
    $dark={dark}
    className={`text-center fw-bold rounded-pill px-3 py-2 text-uppercase ${className}`}
  >
    {children}
  </Pill>
)

const SubPill = ({children, dark = false, className = ''}) => (
  <Pill
    $sub
    $dark={dark}
    className={`text-center fw-bold rounded-pill px-3 py-1 ${className}`}
  >
    {children}
  </Pill>
)

const FramedImage = styled.img`
  height: ${({$height}) => `${$height}px`};
  object-fit: cover;
`

const Photo = ({src, alt, height = 160, className = ''}) => (
  <FramedImage
    src={src}
    alt={alt}
    $height={height}
    className={`d-block w-100 ${className} rounded-5 border border-primary`}
  />
)

const FanImage = styled.img`
  max-width: 180px;
`

const BrindisImage = styled(FanImage)`
  position: absolute;
  bottom: 0;
  right: 0;
  width: min(220px, 70%);
  max-width: 100%;
`

const FoodHours = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;

  > div {
    background: #fff;
    border: 2px solid ${border};
    border-radius: 16px;
    padding: 0.85rem 0.75rem;
  }

  span,
  strong {
    display: block;
  }

  span {
    font-size: 0.85rem;
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }

  strong {
    font-size: 1.05rem;
  }

  @media (max-width: 420px) {
    grid-template-columns: 1fr;
  }
`

const FoodDishList = styled.ol`
  li {
    margin-bottom: 0.35rem;
  }

  @media (min-width: 576px) and (max-width: 991.98px) {
    columns: 2;
  }
`

const MetroIconImage = styled.img`
  max-width: 170px;
`

const PaleBox = styled.div`
  background: var(--bs-gray-200);
`

const MustSeeBox = styled.div`
  background: var(--bs-gray-200);
  border-radius: 24px;
`

const MustSeeList = styled.ol`
  counter-reset: must-see;
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;

  li {
    counter-increment: must-see;
    display: flex;
    align-items: center;
    gap: 0.65rem;
    font-weight: 700;
    margin-bottom: 0.7rem;
  }

  li:last-child {
    margin-bottom: 0;
  }

  li::before {
    content: counter(must-see);
    width: 28px;
    height: 28px;
    min-width: 28px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: ${pink};
    color: #fff;
    border-radius: 50%;
    font-size: 0.85rem;
    font-weight: 800;
  }

  @media (min-width: 768px) {
    columns: 2;

    li {
      break-inside: avoid;
    }
  }
`

const TicketGrid = styled.div`
  display: grid;
  gap: 0.75rem;
`

const TicketCard = styled.div`
  background: #fff;
  border: 2px solid ${border};
  border-radius: 18px;
  padding: 0.85rem 1rem;
`

const TicketPrice = styled.div`
  color: ${pink};
  font-size: 1.15rem;
  font-weight: 800;
  white-space: nowrap;
`

const InfoCard = styled.div`
  background: var(--bs-gray-200);
  border-radius: 24px;
`

const SafetyList = styled.ul`
  li {
    margin-bottom: 0.45rem;
  }

  li:last-child {
    margin-bottom: 0;
  }
`

const LanguageBox = styled.div`
  background: var(--bs-gray-200);
  border-radius: 24px;
`

const LanguageIntro = styled.p`
  max-width: 850px;
  margin-left: auto;
  margin-right: auto;
`

const PhraseGrid = styled.div`
  display: grid;
  gap: 0.75rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 992px) {
    grid-template-columns: repeat(3, 1fr);
  }
`

const PhraseCard = styled.div`
  background: #fff;
  border: 2px solid ${border};
  border-radius: 18px;
  padding: 0.85rem 1rem;
  font-weight: 700;
`

const PhraseEnglish = styled.span`
  display: block;
  font-size: 0.9rem;
`

const PhraseCatalan = styled.span`
  color: ${pink};
  font-size: 1rem;
  font-weight: 800;
`

const LanguageArrow = styled.span`
  font-size: 1.1em;
  line-height: 1;
`

const SmallFanImage = styled.img`
  width: 110px;
  max-width: 30%;
`

const CtaBox = styled.div`
  border: 5px solid ${pink};
  border-radius: 28px;
  overflow: hidden;
`

const CtaButton = styled(Button)`
  color: var(--bs-primary);
  padding: 1rem 1.75rem;
  font-weight: 900;

  &:hover,
  &:focus {
    background: transparent;
    color: #fff;
    border-color: #fff;
  }
`

const RestaurantBlock = ({title, restaurants}) => (
  <div className="text-center">
    <SubPill className="mb-2">{title}</SubPill>

    {restaurants.map((restaurant) => (
      <div key={restaurant.area} className="mb-2">
        <div className="fw-bold">{restaurant.area}</div>

        <ul className="mb-0 list-unstyled">
          {restaurant.places.map((place) => (
            <li key={place} className="text-decoration-underline">
              {place}
            </li>
          ))}
        </ul>
      </div>
    ))}
  </div>
)

const BarcelonaGuide = (props) => {
  return (
    <Page {...props}>
      <Poster className="mx-auto mb-5 fs-6">
        <Hero
          $background={sagradaClose}
          className="position-relative text-center text-white px-3 py-5 mb-4 d-flex align-items-center justify-content-center rounded-4"
        >
          <HeroContent>
            <HeroTitle className="mb-3">
              Barcelona
            </HeroTitle>

            <HeroSubtitle>
              Everything You Need To Know
            </HeroSubtitle>
          </HeroContent>
        </Hero>

        <section className="bg-white border rounded-4 p-3 p-md-4 mb-4" style={{borderColor: border}}>
          <Row className="g-3">
            <Col xs="12" lg="12">
              <PillTitle className="mb-3 py-2">Food</PillTitle>

              <Row className="g-3 g-lg-4 align-items-stretch">
                <Col xs="12" lg="5">
                  <PaleBox className="h-100 rounded-4 p-3 p-md-4 d-flex flex-column justify-content-between">
                    <div style={{position: 'relative'}}>
                      <SubPill dark className="mb-3">
                        Late dining hours
                      </SubPill>

                      <FoodHours className="text-center fw-bold mb-4">
                        <div>
                          <span>Lunch</span>
                          <strong>1–4 PM</strong>
                        </div>

                        <div>
                          <span>Dinner</span>
                          <strong>8–10 PM</strong>
                        </div>
                      </FoodHours>

                      <SubPill dark className="mb-3">
                        Top 10 Dishes to Try
                      </SubPill>

                      <FoodDishList className="fw-bold ps-4 mb-0">
                        {dishes.map((dish) => (
                          <li key={dish}>{dish}</li>
                        ))}
                      </FoodDishList>

                      <BrindisImage
                        src={brindis}
                        alt="cava Brindis"
                        className="rounded"
                      />
                    </div>
                  </PaleBox>
                </Col>

                <Col xs="12" lg="7">
                  <Row className="g-3">
                    <Col xs="12" md="6">
                      <Photo
                        src={tortilla}
                        alt="Tortilla de patata"
                        height={225}
                      />
                    </Col>

                    <Col xs="12" md="6">
                      <div className="g-3">
                        <Photo
                          src={laBomba}
                          alt="La bomba dish"
                          height={225}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className="g-3">
                      <Photo
                        src={paellaPan}
                        alt="Seafood paella"
                        height={225}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row className="g-3">
                <Col xs="12" md="8">
                  <Row>
                    <SubPill dark className="mt-4 mb-3">
                      Restaurants to Try
                    </SubPill>

                    <Col xs="12" md="6">
                      <RestaurantBlock
                        title="Classic"
                        restaurants={classicRestaurants}
                      />

                      <Photo
                        src={beachView}
                        alt="Barceloneta beach"
                        height={180}
                        className="mt-3"
                      />

                      <Photo
                        src={paellaTable}
                        alt="Paella at a restaurant"
                        height={180}
                        className="mt-3"
                      />
                    </Col>

                    <Col xs="12" md="6">
                      <Photo
                        src={gothicPatio}
                        alt="Gothic Quarter patio"
                        height={180}
                        className="mb-3"
                      />

                      <Photo
                        src={cityStreet}
                        alt="Barcelona city street"
                        height={180}
                        className="mb-3"
                      />

                      <RestaurantBlock
                        title="Alternative"
                        restaurants={alternativeRestaurants}
                      />
                    </Col>
                  </Row>
                </Col>

                <Col xs="12" md="4">
                  <SubPill dark className="mt-4 mb-2">
                    Tipping
                  </SubPill>

                  <p className="mb-2 p-2">
                    Tipping culture in Spain is not like the usual American 20%,
                    rather, round the cents up to the next whole euro.
                  </p>

                  <div className="w-100 text-center">
                    <img
                      src={round}
                      alt="Round up to the next euro"
                      className="w-75"
                    />
                  </div>

                  <PaleBox className="rounded-4 text-center px-3 py-2">
                    <strong>Tip:</strong> If the restaurant you are going to has
                    different timings, it is most likely a tourist restaurant!
                  </PaleBox>
                </Col>
              </Row>
            </Col>

            <Col xs="12" lg="12">
              <div className="h-100 d-flex flex-column">
                <PillTitle className="mb-3">10 Must-See Spots</PillTitle>

                <MustSeeBox className="p-3 p-md-4">
                  <Row className="g-3 g-lg-4 align-items-center">
                    <Col xs="12" lg="6">
                      <MustSeeList>
                        {mustSeeSpots.map((spot) => (
                          <li key={spot}>{spot}</li>
                        ))}
                      </MustSeeList>
                    </Col>

                    <Col xs="12" lg="6">
                      <Row className="g-3">
                        <Col xs="6">
                          <Photo
                            src={sagradaClose}
                            alt="La Sagrada Familia"
                            height={190}
                          />
                        </Col>

                        <Col xs="6">
                          <Photo
                            src={parkGuell}
                            alt="Park Güell view"
                            height={190}
                          />
                        </Col>

                        <Col xs="6">
                          <Photo
                            src={casaBatllo}
                            alt="Casa Batlló"
                            height={190}
                          />
                        </Col>

                        <Col xs="6">
                          <Photo
                            src={museum}
                            alt="Museum interior"
                            height={190}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </MustSeeBox>
              </div>
            </Col>
          </Row>

          <Row className="g-3 mt-3">
            <Col xs="12" lg="7">
              <PillTitle className="mb-3">Transportation</PillTitle>

              <Row className="g-3 g-lg-4 align-items-center">
                <Col xs="12" md="7">
                  <SubPill dark className="mb-3">
                    Barcelona Metro Tickets
                  </SubPill>

                  <TicketGrid>
                    {metroTickets.map((ticket) => (
                      <TicketCard key={ticket.name}>
                        <div className="d-flex justify-content-between align-items-start gap-3">
                          <div>
                            <div className="fw-bold text-decoration-underline">
                              {ticket.name}
                            </div>

                            <div className="small mt-1">
                              {ticket.type}<br />
                              {ticket.journeys}
                            </div>
                          </div>

                          <TicketPrice>{ticket.price}</TicketPrice>
                        </div>
                      </TicketCard>
                    ))}
                  </TicketGrid>
                </Col>

                <Col xs="12" md="5" className="text-center">
                  <MetroIconImage
                    src={metroIcon}
                    alt="Metro illustration"
                    className="w-75 mb-3"
                  />

                  <Photo
                    src={metroStation}
                    alt="Sagrada Familia metro sign"
                    height={170}
                  />
                </Col>
              </Row>

              <PaleBox className="rounded-4 text-center p-3 mt-4">
                <strong>Be ready to walk!</strong> Barcelona is a very walkable city. You won’t
                need a cab or an Uber most of the time, but the metro is a
                great option for quicker or farther trips.
              </PaleBox>
            </Col>

            <Col xs="12" lg="5">
              <div>
                <PillTitle className="mb-3">Safety</PillTitle>

                <SafetyList className="ps-4 mb-4">
                  <li>
                    Be aware of your belongings, as there is some pickpocketing
                    around the city.
                  </li>
                  <li>
                    Keep your phone and wallet tucked away instead of on the
                    table when dining at restaurants.
                  </li>
                </SafetyList>

                <PillTitle className="mb-3">Additional Information</PillTitle>

                <div className="d-flex gap-3 align-items-start mb-3">
                  <div>
                    <p className="mb-2">
                      Be prepared for the heat when visiting from mid-June
                      through the end of August.
                    </p>

                    <SafetyList className="ps-4 mb-0">
                      <li>Little to no air-conditioned places in the city.</li>
                      <li>
                        Many locals use abanicos to stay cool. They can be found
                        easily around the city!
                      </li>
                    </SafetyList>
                  </div>

                  <SmallFanImage src={fan} alt="Spanish hand-held fan" />
                </div>

                <Photo
                  src={metroEntrance}
                  alt="Barcelona metro entrance"
                  height={170}
                  className="mt-auto"
                />
              </div>
            </Col>
          </Row>
        </section>

        <section className="bg-white border rounded-4 p-3 p-md-4" style={{borderColor: border}}>
          <Row className="g-4">
            <Col xs="12">
              <PillTitle className="mb-3">Language</PillTitle>

              <LanguageBox className="p-3 p-md-4">
                <LanguageIntro className="text-center fw-semibold mb-3">
                  In Barcelona, the two official languages are Catalan and Spanish
                  (Castilian). Most people in Barcelona speak both languages, but
                  with Catalan being the native language, knowing some basic
                  phrases is always appreciated!
                </LanguageIntro>

                <SubPill dark className="mb-3">
                  Useful Catalan Phrases
                </SubPill>

                <PhraseGrid>
                  {catalanPhrases.map(([english, catalan]) => (
                    <PhraseCard key={`${english}-${catalan}`}>
                      <PhraseEnglish>{english}</PhraseEnglish>

                      <div className="d-flex align-items-center mt-1">
                        <LanguageArrow className="d-inline-flex align-items-center justify-content-center fw-bold me-2">
                          <i className="fa fa-arrow-right" />
                        </LanguageArrow>

                        <PhraseCatalan>{catalan}</PhraseCatalan>
                      </div>
                    </PhraseCard>
                  ))}
                </PhraseGrid>
              </LanguageBox>
            </Col>
          </Row>

          <Row className="g-3 mt-4">
            <Col xs="12">
              <CtaBox className="text-center p-4 p-md-5">
                <h2 className="text-primary display-6 fw-bold mb-2">Barcelona</h2>

                <p className="fw-bold mb-4" style={{fontSize: '1.1rem'}}>
                  Do you want to experience the city with us?
                </p>

                <Button
                  color="primary"
                  size="lg"
                  className="rounded-pill p-3"
                  href="/web/barcelona-tours"
                >
                  Check out our tours!
                </Button>
              </CtaBox>
            </Col>
          </Row>
        </section>

        <div className="text-center small fw-bold mt-3">
          <a href="https://www.instagram.com/goforajourney_tours/" target="_blank" rel="noopener noreferrer">@goforajourney_tours</a>
        </div>
      </Poster>
    </Page>
  )
}

export default BarcelonaGuide